import React from 'react'
import PayrollCalculator from '../components/PayrollCalculator'
import {MapPin, DollarSign, TrendingUp} from 'lucide-react'

const GeorgiaCalculatorPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-emerald-50 py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-4">
              <MapPin className="w-10 h-10 text-blue-800 mr-3" />
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
                Georgia Payroll Calculator
              </h1>
            </div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Calculate your Georgia paycheck with accurate state tax rates. Free payroll calculator for Georgia employees and employers.
            </p>
          </div>

          {/* Calculator with GA pre-selected */}
          <PayrollCalculator defaultState="Georgia" />
        </div>
      </section>

      {/* SEO Content */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Payroll Calculator Georgia - Accurate Tax Estimates
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Georgia has a graduated state income tax system with rates ranging from 1% to 5.75%. Our Georgia payroll calculator automatically applies these rates based on your income level, ensuring you get an accurate estimate of your take home pay. Whether you work in Atlanta, Savannah, Augusta, or anywhere else in the Peach State, this calculator provides precise paycheck calculations.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Georgia's tax brackets are adjusted based on filing status, and our calculator accounts for the state's standard deduction. Combined with federal taxes, Social Security (6.2%), and Medicare (1.45%), you'll see exactly how much of your gross pay becomes net pay.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-blue-50 p-6 rounded-lg">
              <DollarSign className="w-8 h-8 text-blue-800 mb-3" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Georgia State Tax Rates</h3>
              <ul className="text-gray-600 space-y-2">
                <li>• 1% on income up to $750 (Single)</li>
                <li>• 2% - 3% on middle income brackets</li>
                <li>• 4% - 5% on higher income levels</li>
                <li>• 5.75% on income over $7,000</li>
              </ul>
            </div>

            <div className="bg-emerald-50 p-6 rounded-lg">
              <TrendingUp className="w-8 h-8 text-emerald-700 mb-3" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Why Use Our GA Calculator</h3>
              <ul className="text-gray-600 space-y-2">
                <li>• Instant accurate calculations</li>
                <li>• Updated with latest GA tax rates</li>
                <li>• Accounts for federal + state taxes</li>
                <li>• Free and no registration required</li>
              </ul>
            </div>
          </div>

          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              How to Calculate Georgia Paycheck Taxes
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Calculating your Georgia paycheck involves several deductions. First, federal income tax is withheld based on IRS tax brackets and your W-4 filing status. Then, Georgia state income tax is calculated using the state's progressive tax structure. Finally, FICA taxes (Social Security and Medicare) are deducted at standard federal rates. Our calculator handles all these computations automatically, giving you a detailed breakdown of each deduction and your final take home pay.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-blue-800 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Calculate Your Georgia Take Home Pay
          </h2>
          <p className="text-blue-100 mb-6">
            Free Georgia payroll calculator with accurate state and federal tax rates.
          </p>
          <a
            href="#calculator"
            className="inline-block bg-white text-blue-800 font-semibold px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Calculate Now
          </a>
        </div>
      </section>
    </div>
  )
}

export default GeorgiaCalculatorPage
